<template>
  <div class="main-content bg-default" id="page-login">
    <!-- Navbar -->
    <base-nav
      class="navbar-top navbar-horizontal navbar-dark"
      containerClasses="px-4 container"
      expand
    >
      <router-link slot="brand" class="navbar-brand" to="/">
        <img src="img/brand/white.png" />
      </router-link>

      <template v-slot="{ closeMenu }">
        <!-- Collapse header -->
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img src="/img/brand/green.png" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <button
                type="button"
                @click="closeMenu"
                class="navbar-toggler"
                aria-label="Toggle sidenav"
              >
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
        <!-- Navbar items -->
        <ul class="navbar-nav ml-auto">
          <!-- <li class="nav-item">
            <router-link class="nav-link nav-link-icon" to="/profile">
              <i class="ni ni-single-02"></i>
              <span class="nav-link-inner--text">Profile</span>
            </router-link>
          </li> -->
        </ul>
      </template>
    </base-nav>
    <!-- Header -->
    <div class="header bg-gradient-success py-8 py-lg-8">
      <div class="container">
        <div class="header-body text-center mb-4">
          <div class="row justify-content-center">
            <div class="col-lg-5 col-md-6">
              <h1 class="text-white">Chào mừng bạn quay lại hệ thống!</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5 vld-parent">
      <slide-y-up-transition mode="out-in" origin="center top">
        <router-view></router-view>
      </slide-y-up-transition>
    </div>
    <footer class="py-5 footer-auth">
      <div class="container">
        <div class="row align-items-center justify-content-xl-between">
          <div class="col-xl-6">
            <div class="copyright text-center text-xl-left text-muted">
              &copy; {{ year }}
              <a
                href="https://dsolu.com"
                class="font-weight-bold ml-1"
                target="_blank"
                >DSOLU Việt Nam</a
              >
            </div>
          </div>
          <div class="col-xl-6">
            <ul
              class="nav nav-footer justify-content-center justify-content-xl-end"
            >
              <li class="nav-item">
                <a href="https://dsolu.com" class="nav-link" target="_blank"
                  >DSOLU Việt Nam</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import { SlideYUpTransition } from "vue2-transitions";

export default {
  name: "auth-layout",
  components: {
    SlideYUpTransition
  },
  data() {
    return {
      year: new Date().getFullYear(),
      showMenu: false
    };
  }
};
</script>
<style lang="scss">
.main-content {
  background-color: #172b4d;
}
.footer-auth {
  position: absolute;
  width: 100%;
  bottom: 0px;
  .red {
    color: red;
  }
}
#page-login {
  min-height: 100vh;
  .navbar {
    z-index: 1;
  }
  .header {
    z-index: 1;
  }
  .container {
    z-index: 3;
  }
}
@media only screen and (max-width: 375px) and (max-height: 700px) {
  #page-login {
    .header {
      padding-top: 3rem !important;
    }
  }
}
@media (min-width: 992px) {
  #page-login {
    .header {
      padding-top: 6rem !important;
    }
  }
}
//ipad
@media only screen and (width: 768px) and (height: 1024px) {
  #page-login {
    .header {
      padding-top: 15rem !important;
    }
  }
}
//ipad pro
@media only screen and (width: 1024px) and (height: 1366px) {
  #page-login {
    .header {
      padding-top: 20rem !important;
    }
  }
}
</style>
